import React from 'react';
import { Navigate } from 'react-router-dom';

// This page is deprecated - RetreatLandingPage now handles center selection
export default function CentersPage() {
  return <Navigate to="/retreat" replace />;
}
